/* eslint-disable default-param-last */
import {
  CERT_DETAILS_SIDE_PANEL_VISIBLE,
  SET_SIDE_PANEL_BODY_LOADING,
  SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS,
  SET_SIDE_PANEL_CHILDREN_ROLES,
  SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS,
  SET_SIDE_PANEL_ENTITLEMENT_ROLES,
  SET_SIDE_PANEL_ERROR,
  SET_SIDE_PANEL_HISTORY2_ACCOUNTS,
  SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS,
  SET_SIDE_PANEL_HISTORY2_ROLES,
  SET_SIDE_PANEL_HISTORY2_USERS,
  SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS,
  SET_SIDE_PANEL_SOD_ENTITLEMENTS,
  SET_SIDE_PANEL_SUMMARY_ACCOUNTS,
  SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS,
  SET_SIDE_PANEL_SUMMARY_ROLES,
  SET_SIDE_PANEL_SUMMARY_USERS,
  SIDE_PANEL_INITIAL_LOAD,
  SIDE_PANEL_LOAD_MORE_BUTTON,
} from '../types';

const INITIAL_STATE = {
  isSidePanelVisible: false,
  isSidePanelLoading: false,
  isSidePanelError: false,
  sidePanelUsers: {
    summary: null,
    history: {
      employment: null,
      audit: null,
    },
  },
  sidePanelRoles: {
    summary: null,
    history: {
      access: null,
      audit: null,
    },
    entitlements: null,
    children: null,
  },
  sidePanelAccounts: {
    summary: null,
    history: {
      access: null,
      audit: null,
    },
  },
  sidePanelEntitlements: {
    summary: null,
    history: {
      access: null,
      audit: null,
    },
    sod: null,
    privileges: null,
    children: null,
    dependents: null,
  },
};

const sidePanelReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case CERT_DETAILS_SIDE_PANEL_VISIBLE:
      return {
        ...state,
        isSidePanelVisible: action?.payload,
      };

    case SET_SIDE_PANEL_ERROR:
      return {
        ...state,
        isSidePanelError: action?.payload,
      };

    case SET_SIDE_PANEL_BODY_LOADING:
      return {
        ...state,
        isSidePanelLoading: action?.payload,
      };

    case SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS:
      return {
        ...state,
        sidePanelEntitlements: {
          ...state.sidePanelEntitlements,
          summary: action?.payload,
        },
      };

    case SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS:
      return {
        ...state,
        sidePanelEntitlements: {
          ...state.sidePanelEntitlements,
          history: {
            ...state.sidePanelEntitlements.history,
            audit: action?.payload,
          },
        },
      };

    case SET_SIDE_PANEL_SOD_ENTITLEMENTS:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            sod: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            sod: {
              ...state.sidePanelEntitlements.sod,
              risks: [
                ...state.sidePanelEntitlements.sod.risks,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    case SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            privileges: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            privileges: {
              ...state.sidePanelEntitlements.privileges,
              privileges: [
                ...state.sidePanelEntitlements.privileges.privileges,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    case SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            children: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            children: {
              ...state.sidePanelEntitlements.children,
              childEntList: [
                ...state.sidePanelEntitlements.children.childEntList,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    case SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            dependents: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelEntitlements: {
            ...state.sidePanelEntitlements,
            dependents: {
              ...state.sidePanelEntitlements.dependents,
              mappedEntList: [
                ...state.sidePanelEntitlements.dependents.mappedEntList,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    case SET_SIDE_PANEL_SUMMARY_ACCOUNTS:
      return {
        ...state,
        sidePanelAccounts: {
          ...state.sidePanelAccounts,
          summary: action?.payload,
        },
      };

    case SET_SIDE_PANEL_HISTORY2_ACCOUNTS:
      return {
        ...state,
        sidePanelAccounts: {
          ...state.sidePanelAccounts,
          history: {
            ...state.sidePanelAccounts.history,
            audit: action?.payload,
          },
        },
      };

    case SET_SIDE_PANEL_SUMMARY_USERS:
      return {
        ...state,
        sidePanelUsers: {
          ...state.sidePanelUsers,
          summary: action?.payload,
        },
      };

    case SET_SIDE_PANEL_HISTORY2_USERS:
      return {
        ...state,
        sidePanelUsers: {
          ...state.sidePanelUsers,
          history: {
            ...state.sidePanelUsers.history,
            audit: action?.payload,
          },
        },
      };

    case SET_SIDE_PANEL_SUMMARY_ROLES:
      return {
        ...state,
        sidePanelRoles: {
          ...state.sidePanelRoles,
          summary: action?.payload,
        },
      };

    case SET_SIDE_PANEL_HISTORY2_ROLES:
      return {
        ...state,
        sidePanelRoles: {
          ...state.sidePanelRoles,
          history: {
            ...state.sidePanelRoles.history,
            audit: action?.payload,
          },
        },
      };

    case SET_SIDE_PANEL_ENTITLEMENT_ROLES:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelRoles: {
            ...state.sidePanelRoles,
            entitlements: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelRoles: {
            ...state.sidePanelRoles,
            entitlements: {
              ...state.sidePanelRoles.entitlements,
              roleEntList: [
                ...state.sidePanelRoles.entitlements.roleEntList,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    case SET_SIDE_PANEL_CHILDREN_ROLES:
      if (action?.loadMoreStatus === SIDE_PANEL_INITIAL_LOAD) {
        return {
          ...state,
          sidePanelRoles: {
            ...state.sidePanelRoles,
            children: action?.payload,
          },
        };
      }

      if (action?.loadMoreStatus === SIDE_PANEL_LOAD_MORE_BUTTON) {
        return {
          ...state,
          sidePanelRoles: {
            ...state.sidePanelRoles,
            children: {
              ...state.sidePanelRoles.children,
              childRoleList: [
                ...state.sidePanelRoles.children.childRoleList,
                ...action.payload,
              ],
            },
          },
        };
      }

      return state;

    default:
      return state;
  }
};

export default sidePanelReducer;
